
import Component from './component';
import createComponentFactory from '../createComponent';
import { hideChildAction, showChildAction } from '../action/navGlobalAction';
import { TweenMax, Expo } from 'gsap/umd/TweenMax';

class NavGlobal extends Component {

  constructor(element, context, options) {
    super(element, context, options);

    // ナビゲーション大項目
    this.listItem = element.querySelectorAll('.js-navGlobal__item');

    // ナビゲーション大項目のいずれかが表示されているか
    this._isSubMenuShown = false;

    // 現在表示されているメニュー
    this._currentSubMenu = null;

    // 最後にhoverされたメニュー
    this._hoveredItem = null;

    this._handleItemMouseEnter = this._handleItemMouseEnter.bind(this);
    this._handleItemMouseLeave = this._handleItemMouseLeave.bind(this);
    this._handleNavMouseEnter = this._handleNavMouseEnter.bind(this);
    this._handleNavMouseLeave = this._handleNavMouseLeave.bind(this);
  }

  _addEvents() {

    for(let item of this.listItem) {

      item.addEventListener('mouseenter', this._handleItemMouseEnter);
      item.addEventListener('mouseleave', this._handleItemMouseLeave);
    }

    this.element.addEventListener('mouseenter', this._handleNavMouseEnter);
    this.element.addEventListener('mouseleave', this._handleNavMouseLeave);
  }

  _removeEvents() {

    for(let item of this.listItem) {
      item.removeEventListener('mouseenter', this._handleItemMouseEnter);
      item.removeEventListener('mouseleave', this._handleItemMouseLeave);
    }

    this.element.removeEventListener('mouseenter', this._handleNavMouseEnter);
    this.element.removeEventListener('mouseleave', this._handleNavMouseLeave);
  }

  _handleNavMouseEnter() {

  }

  _handleNavMouseLeave() {
    this._hoveredItem = null;
  }

  _handleItemMouseEnter(evt) {
    this._hoveredItem = evt.currentTarget;

    this.showSubMenu();
  }

  _handleItemMouseLeave(evt) {
    setTimeout(() => {

      this.hideSubMenu();
      this._currentMenu = this._hoveredItem;

      this.showSubMenu();
    }, 90);
  }

  showSubMenu() {

    if(this._isSubMenuShown) {
      return;
    }

    this._isSubMenuShown = true;
    this._currentMenu = this._hoveredItem;

    if(!this._currentMenu) {
      this._isSubMenuShown = false;
      return;
    }

    // const subMenu = this._currentMenu.querySelector('.js-navGlobal__sub');
    //
    // TweenMax.to(subMenu, .25, {
    //   autoAlpha: 1,
    //   ease: Expo.easeOut
    // });

    this._currentMenu.dataset.hover = true;
    this.channel.sendUpstream(showChildAction);
  }

  hideSubMenu() {
    this._isSubMenuShown = false;

    delete this._currentMenu.dataset.hover;

    // const subMenu = this._currentMenu.querySelector('.js-navGlobal__sub');
    //
    // TweenMax.to(subMenu, .25, {
    //   autoAlpha: 0
    // });

    this.channel.sendUpstream(hideChildAction);
  }

  didRegisterComponent() {
    this._addEvents();
  }

  didUnregisterComponent() {
    this._removeEvents();
  }
}

export default createComponentFactory(NavGlobal)



// WEBPACK FOOTER //
// ./src/js/app/component/navGlobal.js